import React from 'react';
import { amplitudeLogEvent } from '../../helpers/amplitude-helper';
import { Modal } from '../modal';
import './index.less';

interface IReportProblemProps {
	itemId: string;
	itemTitle?: string;
}

interface IReportProblemState {
	showForm: boolean;
	selected: string | null;
}

export class ReportProblem extends React.Component<IReportProblemProps, IReportProblemState> {
	state: IReportProblemState = {
		showForm: false,
		selected: null,
	};

	handleShowModal = () => {
		this.setState({ showForm: true, selected: null });
	};

	handleHideModal = () => {
		this.setState({ showForm: false });
	};

	handleOptionChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
		const problemType = event.target.value;
		this.setState({ selected: problemType });
	};

	handleSubmit = (event: React.FormEvent) => {
		const { itemId, itemTitle } = this.props;
		event.preventDefault();
		this.handleHideModal();
		amplitudeLogEvent('Item - Problem', {
			'Item Id': itemId,
			Title: itemTitle || 'Not Set',
			Type: this.state.selected,
		});
	};

	render() {
		const { showForm, selected } = this.state;
		const options = [
			{
				value: 'willNotPlay',
				label: "Video won't play",
			},
			{
				value: 'buffering',
				label: 'Video keeps buffering',
			},
			{
				value: 'audio',
				label: 'Problems with audio',
			},
			{
				value: 'video',
				label: 'Problems with video picture',
			},
			{
				value: 'other',
				label: 'Other',
			},
		];

		return (
			<div className="report-problem">
				{/* TODO: Fix this the next time the file is edited. */}
				{/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/anchor-is-valid, jsx-a11y/no-static-element-interactions */}
				<a onClick={this.handleShowModal}>Report a problem</a>
				{showForm ? (
					<Modal title="What type of problem are you experiencing?" onClose={this.handleHideModal}>
						<form onSubmit={this.handleSubmit}>
							{options.map((opt, index) => (
								<div key={index}>
									<input
										id={opt.value}
										type="radio"
										name="type"
										onChange={this.handleOptionChanged}
										value={opt.value}
									/>
									<label htmlFor={opt.value}>{opt.label}</label>
								</div>
							))}
							<div className="submit-wrapper">
								<button type="submit" disabled={!selected}>
									Submit
								</button>
							</div>
						</form>
					</Modal>
				) : null}
			</div>
		);
	}
}
